import { GlButton } from '@gitlab/ui';
import { helpPagePath } from '~/helpers/help_page_helper';
import { i18nHelpText } from '../../constants';
export default {
    name: 'EscalationPolicyHelpState',
    POLICIES_PATH: helpPagePath('operations/incident_management/escalation_policies.md'),
    i18n: i18nHelpText,
    components: {
        GlButton
    }
};
